































import Content from '@/components/common/Content.vue'
import { Component } from 'vue-property-decorator'
import Configuration from "@/components/products/schatzbuch/steps/ConfigurationImpl.vue"
import Design from "@/components/products/schatzbuch/design/DesignImpl.vue"
import Warning from "@/components/common/Warning.vue"
import Headline from "@/components/products/schatzbuch/TreasureBookHeadline.vue"
import ProductPreview from "@/components/products/schatzbuch/design/ProductPreviewImpl.vue"
import { AppModule, Step } from "@/store/modules/app"
import { TreasureBookModule } from "@/store/modules/treasureBook"
import { TextCanvasConfig } from '@/components/common/TextCanvas.vue'
import CartButton from "@/components/products/schatzbuch/util/CartButton.vue"
import Gift from "@/components/products/schatzbuch/GiftImpl.vue"
import GiftOptionsButton from "@/components/common/GiftOptionsButton.vue"
import { CoverType } from '@/rest/models'
import TagCommander from "@/components/common/TagCommander.vue"
import ShippingOverlay from "@/components/common/ShippingOverlay.vue"
import Impressum from '@/components/Impressum.vue'

@Component({
  name: "treasure-book-content",
  components: {
    Headline,
    CartButton,
    Design,
    Configuration,
    Warning,
    ProductPreview,
    GiftOptionsButton,
    Gift,
    TagCommander,
    ShippingOverlay,
    Impressum
  }
})
export default class TreasureBookContent extends Content {
    private showCartButton: boolean = true
 
    toggleFooterButton(state:boolean) {
      this.showCartButton = state
    }

    created() {
      this.initSteps()
      this.initProductName()
    }

    initSteps(): void {
      let nameTextConfig = new TextCanvasConfig(24, 24, 1.5, 287, 40, '"Janda", sans-serif', 2, "400")
      let backTextConfig =  new TextCanvasConfig(7, 14, 1.5, 174, 140, '"Kindergarten", sans-serif', 9, "400")
      let innerPlaceholderStyle = "position: absolute; top: 30px; width: 100px; left: 10px; opacity: .4; z-index: 10; pointer-events: none; touch-action: none;"
      let backPlaceholderStyle = "position: absolute; top: 27px; width: 100px; left: 28px; opacity: .4; z-index: 100; pointer-events: none; touch-action: none;"
      AppModule.SET_STEPS([
          new Step("Name des Kindes", "enter-name", false, undefined, [[174, 148], [480, 420], [228.45, 118]], "", nameTextConfig),
          new Step("Elternteil", "customize-parent", false, undefined, [[150, 150], [600, 600], [48,38]], "", undefined),
          new Step("Foto des Kindes", "inner-image-upload", true, 'innerImage', [[120, 150], [510,630], [250,20]], "Wir empfehlen für Fotos eine Mindestauflösung von 150 dpi. Bitte beachten Sie, dass Ihr Bild mindestens 510 x 1100 px groß sein muss, um an dieser Stelle verwendet werden zu können. Bitte verwenden Sie eine Bilddatei im Format *.jpg oder *.jpeg. Bitte achten Sie darauf, dass die Größe der Bilddatei nicht mehr als 50 MB beträgt. Die Datei muss im Farbraum RGB angelegt sein.", undefined, innerPlaceholderStyle),
          new Step("Widmung", "enter-dedication", true, undefined, [[150, 150], [600, 600], [48,38]], "", backTextConfig, backPlaceholderStyle)])
    }

    initProductName(): void {
      let coverType = AppModule.productVariant;
      if(coverType == CoverType.HardCover) {
        TreasureBookModule.SetCoverType(CoverType.HardCover)
        AppModule.SetProductID("80064")
      }else {
        TreasureBookModule.SetCoverType(CoverType.SoftCover)
        AppModule.SetProductID("80070")
      }
    }

    get showGiftOptions() {
        return AppModule.showGiftOptions
    }

}
